export enum FieldTypeEnum {
  NATIVE = "NATIVE",
  CUSTOM_FIELD = "CUSTOM_FIELD",
}
